import { RangeReadable } from "./range-readable";

interface RangeLike{
	min:number;
	max:number;
}

export class Range extends RangeReadable{
	constructor(
		min=Infinity,
		max=-Infinity,
	){
		super(min,max);
	}

	public fromArray(numbers:number[]){
		this.min=numbers[0];
		this.max=numbers[1];
	}

	public copy(that:RangeLike){
		this.min=that.min;
		this.max=that.max;
		return this;
	}

	public clone():this{
		return new (<any>this.constructor)().copy(this);
	}

	public set(min:number, max:number){
		this.min=min;
		this.max=max;
	}

	public *[Symbol.iterator](){
		yield this.min;
		yield this.max;
	}

	public makeEmpty(){
		this.min=Infinity;
		this.max=-Infinity;
		return this;
	}

	public expandByPoint(v:number){
		if(this.min>v)
			this.min=v;
		if(this.max<v)
			this.max=v;
		return this;
	}

	public expandByPoints(list:Iterable<number>){
		for(const v of list)
			this.expandByPoint(v);
		return this;
	}

	public expandByScaler(v:number){
		this.min-=v;
		this.max+=v;
		return this;
	}

	public translate(delta:number){
		this.min+=delta;
		this.max+=delta;
		return this;
	}

	public scale(factor:number){
		this.min*=factor;
		this.max*=factor;
		return this;
	}

	public union(that:Range){
		this.min=Math.min(this.min,that.min);
		this.max=Math.min(this.max,that.max);
	}

	public override intersection(that:RangeLike){
		this.min=Math.max(this.min,that.min);
		this.max=Math.min(this.max,that.max);
		return this;
	}

	public override _intersection(that:RangeLike){
		this.min=Math.max(this.min,that.min);
		this.max=Math.min(this.max,that.max);
		return this;
	}

	public random(generator:()=>number){
		return generator()*(this.max-this.min)+this.min;
	}

	public splitRange(splitCount: number) {
		const dif = this.max - this.min;
		const step = dif / (splitCount - 1);

		return Array.from(Array(splitCount).keys()).map((i) => {
			const value = this.min + step * i;
			return value;
		});
	}
}

export namespace Range{
	export function fromArray(numbers:number[]){
		return new Range(numbers[0],numbers[1]);
	}

	export function fromPoints(numbers:Iterable<number>){
		const r=new Range();
		return r.expandByPoints(numbers);
	}

	export function infinite(){
		return new Range(-Infinity,+Infinity);
	}
}
